import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  fetchOrganizations,
  getOrganizationBankPaySetting,
} from '~/javascripts/admin/actions/organization';
import { toQueryParams } from '~/javascripts/admin/utils';
import type { PrivateMoneyFormValues } from '..';
import FormErrorMessage from '../../../atoms/FormErrorMessage';
import Grid from '../../../atoms/Grid';
import Label from '../../../atoms/Label';
import Required from '../../../atoms/Required';
import Select from '../../../atoms/Select';
import TextBox from '../../../atoms/TextBox';

const OrganizationSelector = () => {
  const { register, control, setValue } = useFormContext<PrivateMoneyFormValues>();
  const [organizations, setOrganizations] = useState<
    Awaited<ReturnType<typeof fetchOrganizations>>['rows']
  >([]);

  useEffect(() => {
    fetchOrganizations(toQueryParams({ per_page: 10000 })).then((json) => {
      if (json.count !== 0) {
        // Put the first org to last if it is 'pocketchange'
        // ref: https://github.com/pokepay/pokepay-server/issues/3153
        const [first, ...rest] = json.rows ?? [];
        const sortedRows = first.code === 'pocketchange' ? [...rest, first] : [first, ...rest];
        setOrganizations(sortedRows);
      }
    });
  }, []);

  const setBankPaySetting = (organizationCode: string) => {
    getOrganizationBankPaySetting(organizationCode).then((bankPaySetting) => {
      setValue('bank_pay_iss_type', bankPaySetting.iss_type.substring(3));
      setValue('bank_pay_bankbook_merchant_name', bankPaySetting.bankbook_merchant_name);
      setValue('bank_pay_p_id', bankPaySetting.p_id);
    });
  };

  const organizationOptions = organizations?.map((o) => ({ label: o.name, value: o.code })) ?? [];

  return (
    <>
      <Grid.Item size={2}>
        <Label>
          組織 <Required />
        </Label>
      </Grid.Item>
      <Grid.Item size={4} flexDirection="column">
        <Controller
          name="organization_code"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            <Select
              fullWidth
              isMulti={false}
              options={organizationOptions}
              value={organizationOptions.find((x) => x.value === value)}
              onChange={(option) => {
                onChange(option?.value);
                if (option?.value) {
                  setBankPaySetting(option?.value);
                }
              }}
            />
          )}
        />
        <FormErrorMessage name="organization_code" />
      </Grid.Item>

      <Grid.Divider />

      <Grid.Item size={2}>
        <Label>
          マネー名 <Required />
        </Label>
      </Grid.Item>
      <Grid.Item size={4} flexDirection="column">
        <TextBox fullWidth {...register('name', { required: 'マネー名を入力してください' })} />
        <FormErrorMessage name="name" />
      </Grid.Item>
    </>
  );
};

export default OrganizationSelector;
